
import {defineComponent} from "vue";
import {LibraryOverviewRestDto} from "@/api/pharma-cms-content-block/models";
import CbLibraryOverview from "@/components/layouts/content-pages/wysiwyg/libraries/CbLibraryOverview.vue";
import {ContentBlockTypesEnum} from "@/helpers/functions/enum";
import ContentBlockTypesWithLibrary from "@/models/rules/ContentBlockTypesWithLibrary";
import {generateDomId} from "@/helpers/functions/string";
import {ContentBlockLibraryRestService} from "@/services/rest/cms-content-block/ContentBlockLibraryRestService";

export default defineComponent({
  name: "ButtonCbLibraries",
  emits: ["exceptions", "select"],
  components: {CbLibraryOverview},
  props: {
    cbType: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    class: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      isReady: false as boolean,
      modalId: generateDomId('cbLibrariesModal-') as string,
      tabId: generateDomId() as string,
      contentBlockLibsForType: [] as LibraryOverviewRestDto[],
    };
  },
  watch: {
    cbType: {
      async handler() {
        await this.reloadContent();
      },
      immediate: true
    }
  },
  mounted() {
    this.reloadContent();
  },
  computed: {
    contentBlockTypesWithLibrary(): ContentBlockTypesEnum[] {
      return ContentBlockTypesWithLibrary;
    },
    /**
     * `class` is a reserved word in a template expression, so the prop is read through here.
     */
    buttonClass(): string | undefined {
      return this.class;
    },
  },
  methods: {
    targetId(targetCode: string): string {
        return this.tabId + '_' + targetCode;
    },
    async reloadContent(): Promise<void> {
      this.isReady = false;

      try {
        const cbType = this.cbType as ContentBlockTypesEnum;
        if (this.contentBlockTypesWithLibrary.includes(cbType)) {
          this.contentBlockLibsForType = await ContentBlockLibraryRestService.getInstance()
            .findContentBlockLibsForType(this.cbType);
        } else {
          this.contentBlockLibsForType = [];
        }
      } catch (exceptions: any) {
        this.$emit('exceptions', exceptions);
      }

      this.isReady = true;
    },
  }
})
